/**
 * Formats a number as currency (USD)
 * @param value - The number to format
 * @returns Formatted currency string
 */
export const formatCurrency = (value: string | number | undefined): string => {
  if (!value) return '$0.00'
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numValue)
}

export const formatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber?.trim()) return phoneNumber

  let cleaned = phoneNumber.replace(/\D/g, '')

  // US numbers with leading country code
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    cleaned = cleaned.slice(1)
  }

  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }

  return phoneNumber
}